export default __webpack_public_path__ + "static/media/a2.c6612baf.jpg";